import { Component, Injector, Input } from '@angular/core';
import { BenefitType } from 'app/core/helpers/constants';
import { SubdomainInfo } from 'app/core/models/subdomain-info';
import { BaseFilterComponent } from 'app/core/filter-system';

@Component({
  selector: 'app-sidebar-budgets-filter',
  templateUrl: './sidebar-budgets-filter.component.html',
  styleUrls: ['./sidebar-budgets-filter.component.scss']
})
export class SidebarBudgetsFilterComponent extends BaseFilterComponent<number[]> {
  readonly filterId = 'budgets';

  @Input() filterTransportCount: any;
  @Input() filterProfessionalDevelopmentCount: any;
  @Input() companyInfo: SubdomainInfo;

  transportValue = BenefitType.Transport.valueOf();
  professionalDevelopmentValue = BenefitType.ProfessionalDevelopment.valueOf();
  generalValue = BenefitType.General.valueOf();
  budgetsSelection: { [key: number]: boolean } = {};

  constructor(injector: Injector) {
    super(injector);
  }

  getQueryParamKey(): string {
    return 'budgets';
  }

  parseQueryParam(rawValue: string): void {
    this.budgetsSelection = {};
    rawValue.split(',').forEach(v => {
      this.budgetsSelection[+v] = true;
    });
  }

  buildFilterValue(): number[] {
    const allTypes = Object.values(BenefitType).filter(val => typeof val !== 'string') as number[];
    const result: number[] = [];

    for (const key in this.budgetsSelection) {
      if (!this.budgetsSelection[key]) continue;

      if (+key === this.generalValue) {
        result.push(...allTypes.filter(val => val !== BenefitType.Transport && val !== BenefitType.ProfessionalDevelopment));
      }
      if (+key === this.transportValue) {
        result.push(...allTypes.filter(val => val === BenefitType.Transport));
      }
      if (+key === this.professionalDevelopmentValue) {
        result.push(...allTypes.filter(val => val === BenefitType.ProfessionalDevelopment));
      }
    }

    return result;
  }

  clearSelection(): void {
    this.budgetsSelection = {};
  }

  checkCategory(): void {
    this.onFilterChange();
  }
}
